import CartContainer from "../../../../Components/Applications/Ecommerce/Cart/CartContainer";

const Cart = () => {
  return <CartContainer />;
};

export default Cart;
